(function (global) {
    'use strict';

    global.MeloApps = global.MeloApps || {};

    /**
     * Future HTTP/API repository stub.
     * Swap in composition-root.js when the backend is ready.
     *
     * @param {string} apiBaseUrl
     */
    function HttpMeloAppsRepository(apiBaseUrl) {
        this.apiBaseUrl = apiBaseUrl;

        this.getAll = function () {
            return fetch(this.apiBaseUrl + '/apps')
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Failed to load Melo apps');
                    }

                    return response.json();
                })
                .then(function (payload) {
                    return payload.apps || payload;
                });
        };

        this.getBySlug = function (slug) {
            return fetch(this.apiBaseUrl + '/apps/' + encodeURIComponent(slug))
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Failed to load Melo app');
                    }

                    return response.json();
                });
        };
    }

    global.MeloApps.HttpMeloAppsRepository = HttpMeloAppsRepository;
})(typeof window !== 'undefined' ? window : global);
